import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { formatApiError } from "../../lib/api";
import { LogIn } from "lucide-react";

export default function AdminLogin() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-500">Yükleniyor...</div>;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(form.email, form.password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Giriş başarısız");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-gray-200 bg-white p-10">
        <div className="mb-8">
          <div className="w-10 h-10 bg-[#059669] flex items-center justify-center mb-5">
            <span className="text-white font-display text-sm">FD</span>
          </div>
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#059669]">Yönetim Paneli</p>
          <h1 className="font-display text-3xl tracking-tighter font-black mt-2">Giriş Yap</h1>
        </div>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-[0.18em] text-gray-600 mb-2">E-posta</label>
            <input
              required
              type="email"
              data-testid="login-email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full bg-gray-50 border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-[#059669] focus:ring-1 focus:ring-[#059669]"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.18em] text-gray-600 mb-2">Şifre</label>
            <input
              required
              type="password"
              data-testid="login-password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full bg-gray-50 border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-[#059669] focus:ring-1 focus:ring-[#059669]"
            />
          </div>
          {error && (
            <div data-testid="login-error" className="text-sm text-red-600 border border-red-200 bg-red-50 px-3 py-2">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={submitting}
            data-testid="login-submit"
            className="w-full inline-flex items-center justify-center gap-2 bg-black text-white px-7 py-3.5 text-sm font-semibold uppercase tracking-[0.15em] hover:bg-[#059669] disabled:opacity-50"
          >
            {submitting ? "Giriş yapılıyor..." : <>Giriş <LogIn size={14} /></>}
          </button>
        </form>
      </div>
    </div>
  );
}
